var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as moment from 'moment';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { TRIP_TYPE_ROUND_TRIP_CODE, PAX_TYPE_ADULT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_INFANT_CODE, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_ADULT, PAX_TYPE_CHILD, PAX_TYPE_INFANT, PAX_TYPE_YOUNG_ADULT, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE } from '@ibe.config';
import * as _ from 'lodash';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRAFareAndTaxesComponent = /** @class */ (function () {
    function INDRAFareAndTaxesComponent(sidebarService, route, router, store, currencyService, indraBookingService, bfmStorage, ibeAdminService) {
        var _this = this;
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.store = store;
        this.currencyService = currencyService;
        this.indraBookingService = indraBookingService;
        this.bfmStorage = bfmStorage;
        this.ibeAdminService = ibeAdminService;
        this.isAlive = true;
        this.environment = environment;
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.bookAwardFlight$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.flightInformation$ = this.store.select(fromStore.getFlightInformation);
        this.listOffers$ = this.store.select(fromStore.getListOffers);
        this.allSubscriptions = [];
        this.isLoading = false;
        this.noFaresError = false;
        this.AirTransportationTaxes = ['YQ', 'XP']; // based on phase 1 codes
        this.taxSections1 = [];
        this.taxSections2 = [];
        this.paxTypes = [];
        this.totalTax = 0;
        this.totalFare = 0;
        this.totalPrice = 0;
        this.totalMiles = 0;
        this.noFlights = false;
        this.isDupe = false;
        this.isTTTBookingForCompletion = true;
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
        this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.booked_trip = value;
                _this.flights = value.flights;
            }
        });
        this.bookAwardFlight$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value != _this.bookAwardFlight) {
                _this.bookAwardFlight = value;
            }
        });
        this.listOffers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.listOffers = value;
        });
        this.indraBookingService.triggerPNRFareBreakdown$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value && _this.pnr) {
                _this.INDRA_getFareAndTaxesByPNR(_this.pnr);
            }
        });
        this.flightInformation$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                if (value && value.flight.flight) {
                    if (_this.booked_trip.flights.length === 0) {
                        _this.booked_trip = __assign({}, _this.booked_trip, { flights: [] });
                        _this.booked_trip.flights.push(value.flight.flight);
                        _this.flights = [value.flight.flight];
                        _this.noFlights = false;
                    }
                    else if (_this.booked_trip.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
                        var isInbound = _this.booked_trip.flights.find(function (trip) { return trip.bound === 'inbound'; });
                        if (!isInbound) {
                            _this.booked_trip = __assign({}, _this.booked_trip, { flights: _this.booked_trip.flights.concat(value.flight.flight) });
                        }
                        _this.flights = _this.booked_trip.flights;
                        _this.noFlights = false;
                    }
                    else {
                        // this.noFlights = true;
                    }
                }
            }
        });
    }
    INDRAFareAndTaxesComponent.prototype.ngOnInit = function () {
        this.bookAwardFlight = this.INDRA_isAwardBooking();
        this.isLoading = true;
        var isDuplicateBookingParam = this.route.snapshot.paramMap.get('isDupe');
        this.pnr = this.route.snapshot.paramMap.get('pnr');
        if (isDuplicateBookingParam == null || isDuplicateBookingParam === 'false') {
            this.isDupe = false;
        }
        else {
            this.isDupe = true;
            this.dupe_booked_trip = this.bfmStorage.INDRA_getDupeBookedTrip();
        }
        var isTTTBookingForCompletion = this.route.snapshot.paramMap.get('isTTTBookingForCompletion');
        this.isTTTBookingForCompletion = (isTTTBookingForCompletion == null || isTTTBookingForCompletion === 'false') ? false : true;
        if (this.pnr) {
            this.INDRA_getFareAndTaxesByPNR(this.pnr);
        }
        else if (!this.isDupe) {
            if (this.booked_trip.booking_type == TRIP_TYPE_ROUND_TRIP_CODE && this.booked_trip.flights.length != 2
                && !this.booked_trip.stopover) {
                this.noFlights = true;
            }
            else if (this.booked_trip.flights.length == 0) {
                this.noFlights = true;
            }
            if (!this.noFlights) {
                var param = this.INDRA_constructParameter();
                this.INDRA_getFareAndTaxes(param);
            }
            else {
                for (var i in this.booked_trip.passengers) {
                    this.paxTypes.push(this.typeCode(i));
                }
                this.taxPerPassenger = this.formPassengerCounts(this.paxTypes, null, null);
                this.taxPerPassenger = this.taxPerPassenger.filter(function (passenger) {
                    return passenger.count != 0;
                });
                this.isLoading = false;
            }
        }
        else {
            this.dupe_booked_trip = this.bfmStorage.INDRA_getDupeBookedTrip();
            this.INDRA_getFareAndTaxesByPNR(this.dupe_booked_trip.data.pnr);
        }
    };
    INDRAFareAndTaxesComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub)
                sub.unsubscribe();
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_isAwardBooking = function () {
        try {
            var awardFlag = void 0;
            var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
            if (activeBooking && activeBooking.data.award) {
                awardFlag = activeBooking.data.award;
            }
            return this.bookAwardFlight ? this.bookAwardFlight : (awardFlag ? awardFlag : false);
        }
        catch (error) {
            return false;
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_printFlightDate = function (flight) {
        if (flight) {
            var date = moment(new Date(flight.departure.time));
            return date.format('ddd DD MMM h:mm').toLocaleLowerCase();
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_constructParameter = function () {
        var idInbound;
        var idOffer;
        var listIdOutbound;
        if ((this.booked_trip.booking_type == TRIP_TYPE_ROUND_TRIP_CODE && !this.booked_trip.stopover)
            || (this.booked_trip.booking_type == TRIP_TYPE_ONE_WAY_CODE && !this.booked_trip.stopover)) {
            var outboundFlight = _.cloneDeep(this.flights[0]);
            var inboundFlight = _.cloneDeep(this.flights[1]);
            idInbound = this.booked_trip.booking_type == TRIP_TYPE_ONE_WAY_CODE ? 0 : inboundFlight.idFlight;
            idOffer = [this.INDRA_getSelectedOffer(this.booked_trip)];
            listIdOutbound = this.listOffers && this.listOffers.flexPremiumPricer ? [1] : [outboundFlight.idFlight]; // outbound id during flexPremiumPricer scenario is always 1
        }
        else if (this.booked_trip.booking_type == TRIP_TYPE_MULTICITY_CODE || this.booked_trip.stopover) {
            var idOffers = this.booked_trip.flights.map(function (data) {
                return data.options['idOffer'];
            });
            idOffer = idOffers && idOffers.length > 0 ? idOffers.slice(0, 1) : [];
            listIdOutbound = this.flights.map(function (data) {
                return data['idFlight'];
            });
            listIdOutbound = listIdOutbound.filter(function (data) {
                return data != null;
            });
            idInbound = 0;
        }
        var param = {
            forPoints: this.bookAwardFlight,
            idInbound: idInbound,
            idOffer: idOffer,
            listIdOutbound: listIdOutbound
        };
        return param;
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getSelectedOffer = function (booking_trip) {
        /* note: changed the logic on how the selected offer id is retrieved
        const outboundFarebasis = booking_trip.flights[0].options.brand['offer'].outbound.fareBasis;
        const inboundFarebasis = booking_trip.flights[1] ? booking_trip.flights[1].options.brand['offer'].inbound.fareBasis : null;
        const outboundFlightId = listOffers && listOffers.flexPremiumPricer ? 1 : booking_trip.flights[0]['idFlight']; // outbound id during flexPremiumPricer scenario is always 1
        const inboundFlightId = booking_trip.flights[1] ? booking_trip.flights[1]['idFlight'] : null;

        let selectedOfferId;
        if (listOffers) {
            if (outboundFarebasis && inboundFarebasis) {
                const offers = listOffers.listOffers;
                for (const i in offers) {
                    if (JSON.stringify(offers[i].outbound.fareBasis) == JSON.stringify(outboundFarebasis) &&
                        JSON.stringify(offers[i].inbound.fareBasis) == JSON.stringify(inboundFarebasis)) {
                        const groupFlights = offers[i].groupFlights;
                        for (const x in groupFlights) {
                            if (groupFlights[x].idOutBound === outboundFlightId && groupFlights[x].idInBound === inboundFlightId) {
                                selectedOfferId = offers[i].idOffer;
                            }
                        }
                    }
                }
            } else {
                selectedOfferId = booking_trip.flights[0].options.brand['idOffer'];
            }
        }

        return selectedOfferId;
        */
        // id offer is the offer id of the selected inbound flight and brand
        return booking_trip.flights[1] ? booking_trip.flights[1].options.brand['idOffer'] : booking_trip.flights[0].options.brand['idOffer'];
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getFareAndTaxes = function (param) {
        var _this = this;
        this.fareTaxesSubscription = this.indraBookingService.INDRA_getFareAndTaxesBreakdown(param).subscribe(function (response) {
            if (response.errors.length && (response.errors[0].code == "121" || response.errors[0].code == "500")) {
                _this.noFaresError = true;
                _this.isLoading = false;
            }
            else {
                _this.INDRA_processResponse(response);
            }
        }, function (error) {
            _this.INDRA_setBlankDetails();
            _this.isLoading = false;
        });
        this.allSubscriptions.push(this.fareTaxesSubscription);
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getFareAndTaxesByPNR = function (pnr) {
        var _this = this;
        this.fareTaxesByPNRSubscription = this.indraBookingService.INDRA_getPNRFareBreakdown(pnr).subscribe(function (response) {
            _this.INDRA_processResponse(response);
        }, function (error) {
            _this.INDRA_setBlankDetails();
            _this.isLoading = false;
        });
        this.allSubscriptions.push(this.fareTaxesByPNRSubscription);
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_setBlankDetails = function () {
        for (var i in this.booked_trip.passengers) {
            this.paxTypes.push(this.typeCode(i));
        }
        this.taxPerPassenger = this.formPassengerCounts(this.paxTypes, null, null);
        this.taxPerPassenger = this.taxPerPassenger.filter(function (passenger) {
            return passenger.count != 0;
        });
    };
    INDRAFareAndTaxesComponent.prototype.formPassengerCounts = function (paxTypes, currencyCode, data) {
        var _this = this;
        return paxTypes.map(function (type) {
            var countPerType;
            // if (this.booked_trip) {
            // 	countPerType = this.booked_trip.passengers[this.typeName(type)];
            // } else {
            // 	countPerType = data[currencyCode][type].totalPassengers;
            // }
            countPerType = data[currencyCode][type].totalPassengers;
            return {
                type: type,
                name: _this.typeLabel(type),
                count: countPerType,
                totalFare: _this.getTotalbyCurrencyAndPaxType(data, currencyCode, type, countPerType)
            };
        }).filter(function (fare) { return fare && fare.totalFare; });
    };
    INDRAFareAndTaxesComponent.prototype.typeCode = function (type) {
        switch (type) {
            case PAX_TYPE_ADULT:
                return PAX_TYPE_ADULT_CODE;
            case PAX_TYPE_CHILD:
                return PAX_TYPE_CHILD_CODE;
            case PAX_TYPE_INFANT:
                return PAX_TYPE_INFANT_CODE;
            case PAX_TYPE_YOUNG_ADULT:
                return PAX_TYPE_YOUNG_ADULT_CODE;
            default:
                break;
        }
    };
    INDRAFareAndTaxesComponent.prototype.typeLabel = function (type) {
        switch (type) {
            case PAX_TYPE_ADULT_CODE:
                return 'bookingDetails.label.adult';
            case PAX_TYPE_CHILD_CODE:
                return 'bookingDetails.label.child';
            case PAX_TYPE_INFANT_CODE:
                return 'bookingDetails.label.infant';
            case PAX_TYPE_YOUNG_ADULT_CODE:
                return 'bookingDetails.label.youngAdult';
            default:
                break;
        }
    };
    INDRAFareAndTaxesComponent.prototype.typeName = function (type) {
        switch (type) {
            case PAX_TYPE_ADULT_CODE:
                return PAX_TYPE_ADULT;
            case PAX_TYPE_CHILD_CODE:
                return PAX_TYPE_CHILD;
            case PAX_TYPE_INFANT_CODE:
                return PAX_TYPE_INFANT;
            case PAX_TYPE_YOUNG_ADULT_CODE:
                return PAX_TYPE_YOUNG_ADULT;
            default:
                break;
        }
    };
    INDRAFareAndTaxesComponent.prototype.getTotalbyCurrencyAndPaxType = function (data, currencyCode, type, countPerType) {
        if (this.noFlights && !data && !currencyCode) {
            return {
                fare: 0,
                obfee: 0,
                taxes: 0,
                basePrice: 0,
                taxList: null,
                milesPerPax: 0,
                totalMiles: 0
            };
        }
        else if (data && data[currencyCode][type]) {
            // taxes can be NULL or missing
            var taxesCount = 0;
            if (data[currencyCode][type].taxes) {
                // taxesCount = data[currencyCode][type].taxes.filter(tax => tax.currency === currencyCode).reduce((total, next) => total + next.amount, 0) * countPerType;
                taxesCount = data[currencyCode][type].taxes.reduce(function (total, next) { return total + next.amount; }, 0) * countPerType;
            }
            return {
                fare: data[currencyCode][type].basePrice * countPerType,
                // obfee: data[currencyCode][type].obFee ? data[currencyCode][type].obFee : 0,
                obfee: this.INDRA_getOCFee(data, type, currencyCode) ? this.INDRA_getOCFee(data, type, currencyCode) : 0,
                taxes: taxesCount,
                basePrice: data[currencyCode][type].basePrice,
                taxList: data[currencyCode][type].taxes,
                milesPerPax: this.INDRA_getMiles(data, type),
                totalMiles: this.INDRA_getMiles(data, type) ? this.INDRA_getMiles(data, type) * countPerType : 0
            };
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getOCFee = function (data, type, currencyCode) {
        if (this.bookAwardFlight) {
            if (this.bfmStorage.INDRA_getActiveBookedTrip()) {
                var OCFee = this.bfmStorage.INDRA_getActiveBookedTrip().data.fare.flightPrice.totalPrice.obFee;
                return OCFee;
            }
            else {
                return data[currencyCode][type].obFee;
            }
        }
        else {
            return null;
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getMiles = function (data, type) {
        if (this.bookAwardFlight) {
            var milesPoints = void 0;
            if (this.bfmStorage.INDRA_getActiveBookedTrip() && this.bfmStorage.INDRA_getActiveBookedTrip().data.fare.flightPrice.totalPoints) {
                milesPoints = this.bfmStorage.INDRA_getActiveBookedTrip().data.fare.flightPrice.totalPoints.price;
            }
            else {
                milesPoints = data['M'][type].price;
            }
            return milesPoints;
        }
        else {
            return null;
        }
    };
    INDRAFareAndTaxesComponent.prototype.getTaxListSection1ByPassenger = function (data) {
        var _this = this;
        var taxListSection1ByPassenger = [];
        if (data) {
            data.forEach(function (taxItem) {
                if (_this.AirTransportationTaxes.includes(taxItem.code)) {
                    taxListSection1ByPassenger.push(taxItem);
                }
            });
        }
        return taxListSection1ByPassenger;
    };
    INDRAFareAndTaxesComponent.prototype.getTaxListSection2ByPassenger = function (data) {
        var _this = this;
        var taxListSection2ByPassenger = [];
        if (data) {
            data.forEach(function (taxItem) {
                if (!_this.AirTransportationTaxes.includes(taxItem.code)) {
                    taxListSection2ByPassenger.push(taxItem);
                }
            });
        }
        return taxListSection2ByPassenger;
    };
    INDRAFareAndTaxesComponent.prototype.hasTaxList = function (data) {
        return ((data) ? true : false);
    };
    INDRAFareAndTaxesComponent.prototype.computeTotalTicketTaxCost = function (paxTypes, passengers, costType) {
        var total = 0;
        var cost;
        var _loop_1 = function (type) {
            cost = passengers.find(function (data) { return data.type == type; });
            if (cost && cost['totalFare']) {
                total = total + cost['totalFare'][costType];
            }
        };
        for (var _i = 0, paxTypes_1 = paxTypes; _i < paxTypes_1.length; _i++) {
            var type = paxTypes_1[_i];
            _loop_1(type);
        }
        return total;
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getTotalBaseFare = function (passenger) {
        if (this.bookAwardFlight) {
            return passenger.totalFare.milesPerPax + " M";
        }
        else {
            return passenger.totalFare.basePrice + " " + this.currency;
        }
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getTotalMiles = function (passenger) {
        if (this.bookAwardFlight) {
            return this.currencyService.INDRA_formatMiles(passenger.totalFare.totalMiles) + " M + ";
        }
        else {
            return '';
        }
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRAFareAndTaxesComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRAFareAndTaxesComponent.prototype.INDRA_handleClose = function () {
        this.closeSidebar();
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_processResponse = function (response) {
        var _this = this;
        if (response && response.data) {
            var breakdown = response.data.breakdown;
            var itemsCurrencyCode = Object.keys(breakdown)[0];
            for (var i in breakdown[itemsCurrencyCode]) {
                this.paxTypes.push(i);
            }
            this.taxPerPassenger = this.formPassengerCounts(this.paxTypes, itemsCurrencyCode, breakdown);
            if (this.taxPerPassenger && this.taxPerPassenger[0].totalFare && this.taxPerPassenger[0].totalFare.taxList) {
                this.taxPerPassenger[0].totalFare.taxList.forEach(function (taxItem) {
                    if (_this.AirTransportationTaxes.includes(taxItem.code)) {
                        _this.taxSections1.push(taxItem);
                    }
                    else {
                        _this.taxSections2.push(taxItem);
                    }
                });
            }
            var totalObfee = this.computeTotalTicketTaxCost(this.paxTypes, this.taxPerPassenger, 'obfee');
            this.totalFare = this.computeTotalTicketTaxCost(this.paxTypes, this.taxPerPassenger, 'fare');
            this.totalTax = this.computeTotalTicketTaxCost(this.paxTypes, this.taxPerPassenger, 'taxes');
            this.totalPrice = this.totalFare + this.totalTax + totalObfee;
            this.totalMiles = this.computeTotalTicketTaxCost(this.paxTypes, this.taxPerPassenger, 'totalMiles');
            this.isLoading = false;
        }
        else {
            this.INDRA_setBlankDetails();
        }
        this.isLoading = false;
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAFareAndTaxesComponent.prototype.INDRA_printTaxDescription = function (taxSection) {
        var taxDescription;
        if (taxSection.code === 'YQ' && taxSection.type === 'AC') {
            taxDescription = this.INDRA_getTranslation("bookingDetails.taxesTypes.code." + taxSection.code + "." + taxSection.type);
            return taxDescription;
        }
        taxDescription = this.INDRA_getTranslation('bookingDetails.taxesCodes.code.' + taxSection.code);
        if (taxSection.hasSurname) {
            taxDescription += " " + this.INDRA_getTranslation("bookingDetails.taxesTypes.code." + taxSection.code + "." + taxSection.type);
        }
        return taxDescription;
    };
    return INDRAFareAndTaxesComponent;
}());
export { INDRAFareAndTaxesComponent };
